/* @flow */
import { ResponseTypes, ButtonActionTypes } from 'constants/QuickPromotionConstants';
import QuickPromotion from 'entities/QuickPromotion';
import QuickPromotionAction from 'entities/QuickPromotionAction';
import QuickPromotionActions from 'actions/QuickPromotionActions';
import resolveDeeplinkRedirects from 'lib/resolveDeeplinkRedirects';

export const actionHandlers = {
  handleActionLink: (action: QuickPromotionAction) => {
    window.location = action.getActionData();
  },
  handleActionDeeplink: (router: Object, action: QuickPromotionAction) => {
    router.push(resolveDeeplinkRedirects(action.getActionData()));
  },
};

export function handleAction(
    router: Object,
    promotion: QuickPromotion,
    action: QuickPromotionAction) {
  switch (action.getActionType()) {
    case ButtonActionTypes.NONE:
      // do nothing
      break;
    case ButtonActionTypes.LINK:
      actionHandlers.handleActionLink(action);
      break;
    case ButtonActionTypes.DEEPLINK:
      actionHandlers.handleActionDeeplink(router, action);
      break;
    default:
      console.error('Don\'t know how to handle this QP action. The QP shouldn\'t have been shown.'
        + ' action: ' + action.toString()
        + ' offending QP ' + promotion.toString());
      break;
  }
}


export function handleResponse(router: Object, promotion: QuickPromotion, responseType: string) {
  QuickPromotionActions.recordDismissal(promotion, responseType);

  switch (responseType) {
    case ResponseTypes.PRIMARY_ACTION:
      handleAction(router, promotion, promotion.getPrimaryAction());
      break;
    case ResponseTypes.SECONDARY_ACTION:
      const secondaryAction = promotion.getSecondaryAction();
      if (secondaryAction != null) {
        handleAction(router, promotion, secondaryAction);
      } else {
        console.error('QP has no secondary action. This QP should not have been shown.'
            + ' offending QP: ' + promotion.toString());
      }
      break;
    default:
      console.error('Unknown QP response type. This should never happen.'
          + ' responseType: ' + responseType
          + ' offending QP: ' + promotion.toString());
      break;
  }
}



// WEBPACK FOOTER //
// ./src/lib/QuickPromotionActionHandler.js